import axios from 'axios'
import { storageAuthTokenGet } from '../../storage/storageAuthToken';
import Keycloak from "keycloak-js";
import { storageSelectedTenantGet } from '../../storage/storageSelectedTenant';

export const Api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }
});

export const configureApiResponseInterceptor = (keyclockInstance: Keycloak) => {
  Api.interceptors.response.use(
    (response) => {
      if (response.status === 200) {
        return response;
      }
      else {
        const data = response.data;
        console.log("Response data:", data);
        return Promise.reject({ message: data.errorMessage });
      }
    },
    (error) => {
      console.error("Erro na requisição:", error.response)
      if (error.response && error.response.status === 401) {
        keyclockInstance.logout();
      }
      else if (error.response && error.response.status === 500) {
        return Promise.reject(error.response);
      }
      else return Promise.reject(error);
    }
  );
}

Api.interceptors.request.use(
  async (request) => {
    request.headers.Authorization = `Bearer ${storageAuthTokenGet()}`;
    request.headers["Tenant-Name"] = storageSelectedTenantGet();
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

